<template>
  <DefaultLayout>
    <div slot="content">
      <div class="d-flex align-center py-3">
        <div class="title">Default Email Templates</div>
        <v-spacer></v-spacer>
        <v-select dense hide-details :items="templates" :item-text="getTemplateName" :change="getEmailTypeString()" item-value="id" v-model="template" label="Email Template"></v-select>
      </div>
      <v-tabs slider-color="black" active-class="v-tabs_active_item" v-model="emailTemplatesTabs">
        <v-tab class="font-weight-bold" :ripple="false"><v-icon :color="emailTemplatesTabs === 0 ? 'black' : 'blue'" class="mr-1">code</v-icon> Template</v-tab>
        <v-tab class="font-weight-bold" :ripple="false"><v-icon :color="emailTemplatesTabs === 1 ? 'black' : 'blue'" class="mr-1">pageview</v-icon> Preview</v-tab>
      </v-tabs>
      <v-divider></v-divider>
      <v-tabs-items v-model="emailTemplatesTabs">
        <v-tab-item>
          <v-row>
            <v-col cols="12" sm="5" md="4" lg="3">
              <v-text-field required v-model="subject" label="Subject" type="text" ref="subject" :rules="[v => !!v || '']"></v-text-field>
              <div class="d-flex align-center mb-1" v-for="rep in replacements" :key="rep">
                <v-btn tile depressed class="flex-grow-1 mr-1 px-2" @click="drag(rep)">{{ rep }}</v-btn>
              </div>
            </v-col>
            <v-col cols="12" sm="7" md="8" lg="9" class="py-0">
              <codemirror ref="codeMirror" v-model="code" :options="cmOption"></codemirror>
            </v-col>
          </v-row>
          <div class="text-right py-2">
            <v-btn small dark tile depressed color="blue" :loading="loading" @click="saveTemplate">Save Template</v-btn>
          </div>
        </v-tab-item>
        <v-tab-item>
          <p v-html="code"></p>
        </v-tab-item>
      </v-tabs-items>
    </div>
  </DefaultLayout>
</template>

<script>
import { codemirror } from 'vue-codemirror';
import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/ambiance.css';
import 'codemirror/mode/xml/xml.js';
import 'codemirror/theme/base16-light.css';

import { mapState } from 'vuex';
import { GET_EMAIL_TEMPLATES, UPDATE_EMAIL_TEMPLATE, GET_EMAIL_TEMPLATES_REPLACEMENTS } from '@/store/actions.type';
import DefaultLayout from '@/layouts/DefaultLayout';

export default {
  name: 'email-templates',
  components: {
    DefaultLayout,
    codemirror,
  },
  data(){
    return {
      emailTemplatesTabs: 0,
      code: '',
      subject: '',
      replacements: [],
      templatesReplacements: [],
      cmOption: {
        tabSize: 4,
        styleActiveLine: true,
        lineNumbers: true,
        autoCloseTags: true,
        line: true,
        refresh:true,
        mode: 'text/html',
      },
      template: null,
      templateName: '',
      loading:false,
      newReplacement: '{{____}}',
    };
  },
  computed: {
    ...mapState({ templates: state => state.emailTemplates.emailTemplates }),
  },
  watch:{
    template(newId) {
      const t = this.templates.find(x => x.id === newId);
      this.code = t.body;
      this.subject = t.subject;
      this.replacements = t.replacements;
    },
  },
  methods: {
    getTemplateName(item){
      if(!this.templatesReplacements){
        return ''
      }      
      if(this.templatesReplacements.length === 0){
        return ''
      }
      return this.templatesReplacements.find(x => x.templateType === item.type).templateName
    },
    getEmailTypeString(){
      if(!this.templatesReplacements){
        return ''
      }      
      if(this.templatesReplacements.length === 0){
        return ''
      }
      var template = this.templates.find(x => x.id === this.template)
      var rep = this.templatesReplacements.find(x => x.templateType === template.type)
      this.replacements = rep.replacements
      this.templateName = rep.templateName
    },
    async getEmailTemplatesReplacements() {
      try {
        const replacements = await this.$store.dispatch(GET_EMAIL_TEMPLATES_REPLACEMENTS);
        this.templatesReplacements = replacements.list;
      } catch(err) {
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Error getting email templates replacements. Please contact support@planetverify.com',
        });
      }
    },
    drag(replacement) {
      this.$refs.codeMirror.codemirror.replaceSelection(replacement);
    },
    async loadEmailTemplates() {
      const response = await this.$store.dispatch(GET_EMAIL_TEMPLATES);
      this.template = response.list[0].id
      this.code = response.list[0].body
      this.subject = response.list[0].subject
      this.replacements = response.list[0].replacements
    },
    fetchTemplates() {
      this.$store.dispatch(GET_EMAIL_TEMPLATES);
    },
    async saveTemplate() {
      this.loading = true;
      const tt = {
        id: this.template,
        name: 'default template',
        subject: this.subject,
        body: this.code,
        replacements: this.replacements
      };

      try {
        await this.$store.dispatch(UPDATE_EMAIL_TEMPLATE, tt);
        this.loading = false;
        this.$notify({
          type: 'success',
          title: 'Success',
          text: 'Email template saved',
        });
        this.fetchTemplates();
      } catch(err) {
        this.loading = false;
        this.$notify({
          type: 'error',
          title: 'Error!',
          text: 'Error saving template. Please contact support@planetverify.com',
        });
      }
    },
    addReplacement() {
      this.replacements.push(this.newReplacement);
      this.newReplacement = '{{_____}}';
    },
    removeReplacement(rep) {
      this.replacements = this.replacements.filter(x => x != rep);
    },
  },
  async mounted() {
    await this.loadEmailTemplates();
    await this.getEmailTemplatesReplacements();
  },
}
</script>

<style>
.CodeMirror {
  height: 600px;
  font-size: 12px;
}
</style>
